import auth from "./auth";
import appInfo from "./app-info";
import { computed } from "vue";

// Detect if we have started on a survey page that isn't in the menu (NNRC, Mini-Survey, etc.)
// This way we can allow initial access to it in the menu.
let allowInitialHiddenSurvey = false;
let hiddenSurveys = [ 'nnrc', 'colpunomini', 'genericmini', 'mindweb', 'iloilo', 'ipass', 'social' ].map(s => '#/survey/' + s);
if (window && window.location && window.location.href) {
	let url = new URL(window.location.href);
	if (url && url.hash && hiddenSurveys.includes(url.hash.toLowerCase())) {
		allowInitialHiddenSurvey = url.hash.split('/').pop().toLowerCase();
	}
}
let isColpuno = appInfo.siteMode == 'colpuno';

function buildMenu() {
let navMenu = [
	{
		text: "Dashboard",
		path: "/home",
		icon: "home",
	},
	{
		text: "General Survey",
		path: "/survey/general",
		icon: "columnchooser",
		disabled: !isColpuno,
	},
	{
		text: "NNRC Survey",
		path: "/survey/nnrc",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'nnrc',
		disabled: !isColpuno,
	},
	{
		text: "Mind Web Survey",
		path: "/survey/mindweb",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'mindweb',
		disabled: !isColpuno,
	},
	{
		text: "Uni. of Iloilo Survey",
		path: "/survey/iloilo",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'iloilo',
		disabled: !isColpuno,
	},
	{
		text: "Career Potential",
		path: "/survey/aatrium",
		icon: "columnchooser",
		disabled: isColpuno,
	},
	{
		text: "Colpuno Mini Survey",
		path: "/survey/colpunomini",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'colpunomini',
		disabled: !isColpuno,
	},
	{
		text: "Mini Survey",
		path: "/survey/genericmini",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'genericmini',
		disabled: !isColpuno,
	},
	{
		text: "IPASS-Colpuno",
		path: "/survey/ipass",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'ipass',
		disabled: !isColpuno,
	},
	{
		text: "Colpuno Newsletter",
		path: "/survey/social",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'social',
		disabled: !isColpuno,
	},
	{
		text: "Pentagon Survey",
		path: "/survey/royalpent",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'royalpent',
		disabled: !isColpuno,
	},
	{
		text: "Sandbox Survey",
		path: "/survey/sandbox",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'sandbox',
		disabled: !isColpuno,
	},
	{
		text: "Sandbox Mini Survey",
		path: "/survey/sandboxmini",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'sandboxmini',
		disabled: !isColpuno,
	},
	{
		text: "9.0 Niners Anniversary",
		path: "/survey/niner_raffle",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'niner_raffle',
		disabled: !isColpuno,
	},
	{
		text: "Beta Ticket",
		path: "/survey/betaticket",
		icon: "columnchooser",
		visible: auth.isStaff.value || allowInitialHiddenSurvey == 'betaticket',
		disabled: !isColpuno,
	},
	{
		text: "Raffle Lists",
		path: "/raffle",
		icon: "percent",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
	},
	{
		text: "Big 5 Demo",
		path: "/big5",
		icon: "product",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
	},
	{
		text: "Data Dashboard",
		path: "/dashboard/data",
		icon: "datatrending",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
	},
	{
		text: "Platform Dashboard",
		path: "/dashboard/platform",
		icon: "dataarea",
		visible: auth.isStaff.value && false,
		disabled: !isColpuno,
	},
	/*{
		text: "Company",
		path: '/company/1',
		icon: "product",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
	},
	{
		text: "Job Offer Search",
		path: "/joboffer",
		icon: "find",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
	},*/
	/*
	{
		text: "Old Demo",
		icon: "folder",
		visible: auth.isStaff.value,
		disabled: !isColpuno,
		items: [
			{
				text: "Profile",
				path: "/demo/profile",
			},
			{
				text: "Profile List",
				path: "/demo/profile-list",
			},
			{
				text: "Company",
				path: "/demo/company",
			}
		]
	},
	*/
	{
		text: "Management",
		icon: "folder",
		visible: auth.isStaff.value,
		items: [
			{
				text: "Users",
				path: "/manage/employees"
			},
			{
				text: "Results",
				path: "/manage/results"
			}
		]
	}
];

// Filter nav menu based on site mode or other restrictions.
for (var i = 0; i < navMenu.length; i++) {
	let item = navMenu[i];
	if (item.disabled) {
		navMenu.splice(i, 1);
		i--;
	}
}
return navMenu;
}

// Export a computed so consumers react when auth.isStaff changes
const navigation = computed(() => buildMenu());

export default navigation;